import React from 'react';
import { useField } from 'formik';
import { makeStyles } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Typography from '@material-ui/core/Typography';

import { requiredFields } from '../FormPage/FormPage';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'block',
  },

  input: {
    display: 'block',
    marginTop: theme.spacing(1),
    minWidth: 300,
    width: '40%',
  },
}))

type LongInputFieldProps = {
  label: React.ReactNode,
  name: string,
}

const LongInputField = ({ label, name }: LongInputFieldProps) => {
  const classes = useStyles();
  const [field, meta] = useField(name);
  const isRequired = requiredFields[name];
  const hasError = meta.touched && !!meta.error;

  return (
    <FormControl className={classes.root} error={hasError} variant="outlined">
      <FormLabel htmlFor={name}>
        {label} {!isRequired && <Typography variant="caption">(optional)</Typography>}
      </FormLabel>
      <OutlinedInput {...field} className={classes.input} name={name} labelWidth={0} />
      {hasError && (
        <FormHelperText>{meta.error}</FormHelperText>
      )}
    </FormControl>
  )
}

export default LongInputField;
